<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue'
import { logError } from '@repo/shared/utils/logger.util'

withDefaults(
  defineProps<{
    fallback?: string
  }>(),
  {
    fallback: 'Something went wrong',
  },
)

const hasError = ref(false)
const errorMessage = ref('')
const tryAgainLabel = 'Try again'
const reloadPageLabel = 'Reload page'

onErrorCaptured((err) => {
  hasError.value = true
  errorMessage.value = err instanceof Error ? err.message : String(err)
  logError('[ErrorBoundary]', err)
  return false
})

function tryAgain(): void {
  hasError.value = false
  errorMessage.value = ''
}

function reload(): void {
  window.location.reload()
}
</script>

<template>
  <slot v-if="!hasError" />
  <div v-else class="error-boundary">
    <div class="error-boundary__content">
      <h2 class="error-boundary__title">{{ fallback }}</h2>
      <p v-if="errorMessage" class="error-boundary__message">{{ errorMessage }}</p>
      <button class="error-boundry__button" @click="tryAgain">
        {{ tryAgainLabel }}
      </button>
      <button class="error-boundry__button" @click="reload">
        {{ reloadPageLabel }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.error-boundary {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 2rem;
}

.error-boundary__content {
  text-align: center;
  max-width: 400px;
}

.error-boundary__title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.error-boundary__message {
  font-size: 0.875rem;
  color: #666;
  margin-bottom: 1rem;
  word-break: break-word;
}

.error-boundry__button {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;
  font-size: 0.875rem;
  margin: 0 0.25rem;
}

.error-boundry__button:hover {
  background: #f5f5f5;
}
</style>
